"use strict";

exports.__esModule = true;
exports.getOrSetUUIDCookie = exports.getUUIDCookie = exports.uniqid = exports.UUID_COOKIE_NAME = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _md = _interopRequireDefault(require("md5"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This cookie is used on chegg and so will be used on other sites as well for providing user object required
 * by react optimizely sdk
 */
var UUID_COOKIE_NAME = 'V'; // Javascript version of PHP uniqid function which is used to
// create the V cookie on chegg.com

exports.UUID_COOKIE_NAME = UUID_COOKIE_NAME;

var uniqid = function uniqid() {
  var dateMicroseconds = Date.now() / 1000;
  var dateString = dateMicroseconds.toString(16).split('.').join('');

  while (dateString.length < 14) {
    dateString += '0';
  }

  var randomNumber = Math.random() * 1000;
  var randomString = randomNumber.toString();
  return "" + (0, _md["default"])(randomString) + dateString + "." + Math.floor(10000000 + Math.random() * 80000000);
};

exports.uniqid = uniqid;

var getUUIDCookie = function getUUIDCookie(cookieName) {
  if (cookieName === void 0) {
    cookieName = UUID_COOKIE_NAME;
  }

  return _jsCookie["default"].get(cookieName);
};

exports.getUUIDCookie = getUUIDCookie;

var getOrSetUUIDCookie = function getOrSetUUIDCookie(domain, cookieName) {
  var uuidCookie = getUUIDCookie(cookieName);
  if (uuidCookie) return uuidCookie;
  var uuidHash = uniqid();
  var date = new Date(); // V Cookie on chegg.com lasts 10 years

  var expires = new Date(date.getFullYear() + 10, date.getMonth(), date.getDay());

  _jsCookie["default"].set(cookieName != null ? cookieName : UUID_COOKIE_NAME, uuidHash, {
    domain: domain,
    expires: expires
  });

  return uuidHash;
};

exports.getOrSetUUIDCookie = getOrSetUUIDCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/utils/getOrSetUUIDCookie.js
// module id = 5734
// module chunks = 11